import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2A2B2A',
      light: '#3A3B3A',
      dark: '#1A1B1A',
      contrastText: '#F5F5DC',
    },
    secondary: {
      main: '#D8EFFA',
      light: '#E8F5FC',
      dark: '#B8CFD8',
      contrastText: '#2A2B2A',
    },
    background: {
      default: '#e6f8fb40',
      paper: '#ffffff',
    },
    text: {
      primary: '#2A2B2A',
      secondary: '#4A4B4A',
    },
  },
  typography: {
    fontFamily: "'Space Grotesk', sans-serif",
    h1: {
      fontFamily: "'Space Grotesk', sans-serif",
    },
    h2: {
      fontFamily: "'Space Grotesk', sans-serif",
    },
    h3: {
      fontFamily: "'Space Grotesk', sans-serif",
    },
    h4: {
      fontFamily: "'Space Grotesk', sans-serif",
    },
    h5: {
      fontFamily: "'Space Grotesk', sans-serif",
    },
    h6: {
      fontFamily: "'Space Grotesk', sans-serif",
    },
    body1: {
      fontFamily: "'Space Grotesk', sans-serif",
    },
    body2: {
      fontFamily: "'Space Grotesk', sans-serif",
    },
    button: {
      fontFamily: "'Space Grotesk', sans-serif",
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          textTransform: 'none',
          fontFamily: "'Poppins', sans-serif",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(15px)',
          WebkitBackdropFilter: 'blur(15px)',
          borderRadius: 15,
          border: '1px solid rgba(255, 255, 255, 0.18)',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.07)',
        },
      },
    },
    MuiPaper: {
      variants: [
        {
          props: { variant: 'frosted' },
          style: {
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            backdropFilter: 'blur(15px)',
            WebkitBackdropFilter: 'blur(15px)',
            borderRadius: 15,
            border: '1px solid rgba(255, 255, 255, 0.3)',
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
          },
        },
      ],
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(15px)',
          WebkitBackdropFilter: 'blur(15px)',
        },
      },
    },
  },
});

export default theme; 